import React from "react";

export const ReloadIcon = () => (
    <i className="icon ion-ios7-reload" />
);
